
const state = {
	commonPre: 'common', // 通用属性前缀
	commonPreCN: '通用属性', // 通用属性中文前缀
	imageViewerOpen: false, // 图片预览是否打开
}

const mutations = {
	setImageViewerOpen(state, payload) {
		state.imageViewerOpen = payload;
	},
}

export default {
	state,
	mutations
}



// WEBPACK FOOTER //
// ./src/storage/vuex/module/global.js